/**
 * @file Automatically generated by barrelsby.
 */

export * from './vertical-tabs.module';
export * from './vertical-tab/index';
export * from './vertical-tab-group/index';
